import { $t } from '@/i18n';
import {
  XyPageletPropsEditorMeta,
} from '../paramsFormComponents';
import { CATEGORY } from './const';
import logger from '@utils/logger';

export default [
  {
    id: 'pagelet:emitEvent',
    name: $t('k_4167191d'),
    desc: $t('k_6c4d3ff3'),
    category: CATEGORY.LOGIC,
    paramsSchema: {
      type: 'object',
      fields: [
        {
          id: 'eventName',
          title: $t('k_e86f3a8f'),
          type: 'string',
          enum: [
            { label: $t('k_230b1765'), value: '' },
            { label: $t('k_22042ed4'), value: 'presetEventA' },
            { label: $t('k_2ba647c1'), value: 'presetEventB' },
            { label: $t('k_411bd345'), value: 'presetEventC' },
            { label: $t('k_fb29d0db'), value: 'presetEventD' },
            { label: $t('k_cb2c0538'), value: 'presetEventE' },
          ],
          default: '',
        },
        {
          id: 'data',
          type: 'array',
          title: $t('k_d4a9d62c'),
          'uc:allowInterop': true,
          ui: {
            type: 'XyPageletPropsEditor',
            props: {
              getPagelet: () => null,
            },
          },
          items: {
            type: 'object',
            fields: [
              { id: 'key', type: 'string' },
              { id: 'value', type: 'string' },
            ],
          },
        },
      ],
    },
    paramsFormComponents: [
      XyPageletPropsEditorMeta,
    ],
    execute: async (ctx, params) => {
      const { wContext } = ctx.renderer;  // xy 上下文
      const { eventName, data } = params;

      if (!eventName) {
        const msg = $t('k_39c61fb2');
        logger.info(msg);
        throw new Error(msg);
      }

      const kv = {};
      if (Array.isArray(data)) {
        data.forEach((item) => {
          const { key, value } = item;
          kv[key] = value;
        });
      }

      wContext?.container?.$emit(eventName, kv);
    },
  },
];
